import React from 'react';
import { useAuth } from '../hooks/useAuth';
import Landing from './Landing';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Landing onAuthSuccess={() => {/* Auth context will handle state update */}} />;
  }

  return children;
};

export default ProtectedRoute;